const _state = {
  selectedSession: null,
  isRenderedReport: true,
}

export default _state
